// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"5735aaa4","742":"39c3b0d3"}[chunkId] + ".chunk.js";
};